import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/adminSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./reducers/authSlice";

export const store = configureStore({
  reducer: {
    userReducer,
    auth : authReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({}).concat([userApi.middleware]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
